import { useEffect } from "react";

export const AI_SKILL_CHANGED_EVENT = "ai-skill-changed";
export const AI_SKILL_TOOLS = new Set(["create_skill", "upload_skill", "update_skill", "delete_skill"]);

export interface SkillChangedDetail {
  tool: string;
  templateId?: string;
  skillName?: string;
  [key: string]: unknown;
}

export function useSkillChangeListener(onChanged: (detail: SkillChangedDetail) => void) {
  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<SkillChangedDetail>).detail;
      if (detail) onChanged(detail);
    };
    window.addEventListener(AI_SKILL_CHANGED_EVENT, handler);
    return () => window.removeEventListener(AI_SKILL_CHANGED_EVENT, handler);
  }, [onChanged]);
}
